import styled from 'styled-components';
import { Utils } from 'billon-ui';

const { Button: ButtonModule } = Utils;
const { BackButton: BB } = ButtonModule;

export const BackButton = styled(BB)`
  margin-bottom: 25px;
`;
